// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2K93G","itemTitle":"ClientEmergencyInfo_itemTitle__pZyXd","itemText":"ClientEmergencyInfo_itemText__3fogy"};